import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import UserLogoutBar from "../UserLogoutBar";
import LoadingDots from "tenant/loading_dots.gif";
import "../../styles/components/entryflow/LoadingSession.css";

const LoadingSessionComponent: React.FC = () => {
  const { t } = useTranslation();
  const [elapsedTime, setElapsedTime] = useState(0);

  const getLoadingMessage = () => {
    if (elapsedTime < 10) {
      return t("loadingSession.loading");
    } else if (elapsedTime < 30) {
      return t("loadingSession.stillLoading");
    } else if (elapsedTime < 60) {
      return t("loadingSession.warmingUp");
    } else {
      return t("loadingSession.goodThings");
    }
  };

  useEffect(() => {
    let timerId: NodeJS.Timeout | null = setInterval(() => {
      setElapsedTime((prev) => prev + 1);
    }, 1000);
    return () => {
      if (timerId) clearInterval(timerId);
    };
  }, []);

  return (
    <div className="loading-session-container">
      <UserLogoutBar />
      <div className="loading-session-form">
        {/* <div className="completeuser-profile-picture-container">
          {stytchUser?.providers?.[0]?.profile_picture_url ? (
            <img
              src={stytchUser.providers[0].profile_picture_url}
              alt="Profile"
              className="completeuser-profile-picture"
            />
          ) : (
            <div className="completeuser-profile-picture-placeholder">
              {stytchUser?.name?.first_name?.charAt(0) || "?"}
              {stytchUser?.name?.last_name?.charAt(0) || ""}
            </div>
          )}
        </div> */}
        {/* <div className="completeuser-welcome-heading">
          Welcome to Persona, {stytchUser?.name?.first_name || ""}{" "}
          {stytchUser?.name?.last_name || ""}

        </div> */}
        <img src={LoadingDots} alt={t("loadingSession.loadingAlt")} className="loading-session-loading-image" />
        <div className="loading-session-status-message">{getLoadingMessage()}</div>
      </div>
    </div>
  );
};

const LoadingSessionOnlyComponent: React.FC = () => {
  return <LoadingSessionComponent />;
};

export default LoadingSessionComponent;
export { LoadingSessionOnlyComponent };
